import { render } from "./CategoryServicePrimaryAndControl.vue?vue&type=template&id=26a4e6f6&scoped=true&ts=true"
import script from "./CategoryServicePrimaryAndControl.vue?vue&type=script&lang=ts"
export * from "./CategoryServicePrimaryAndControl.vue?vue&type=script&lang=ts"

import "./CategoryServicePrimaryAndControl.vue?vue&type=style&index=0&id=26a4e6f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a4e6f6"]])

export default __exports__